import { render, staticRenderFns } from "./UnlinkButton.vue?vue&type=template&id=5b9f57d6&scoped=true"
import script from "./UnlinkButton.vue?vue&type=script&lang=js"
export * from "./UnlinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f57d6",
  null
  
)

export default component.exports